import { Component, Input, OnInit } from '@angular/core';
import { LotPermissions } from '@app/core/permissions';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { ReleaseStagesLogicService } from '@app/logic/release-stages/release-stages.logic.service';
import {
    IProjectReleaseLotFinancesDto,
    LotTypeEnumId,
    LOT_CONTRACT_TYPE_ENUM,
    LOT_TYPE_ENUM,
    SiteStatusEnumId,
    SITE_STATUS_ENUM
} from '@classictechsolutions/hubapi-transpiled-enums';
import { startCase } from 'lodash';
import { take } from 'rxjs';

@Component({
    selector: 'cb-release-lots-financials',
    templateUrl: './release-lots-financials.component.html',
    styleUrls: ['./release-lots-financials.component.scss'],
    standalone: false
})
export class ReleaseLotsFinancialsComponent implements OnInit {
    public lots: IProjectReleaseLotFinancesDto[];
    public loaded = false;
    @Input() public releaseId: number;
    public LOT_TYPE_ENUM = LOT_TYPE_ENUM;
    public LOT_CONTRACT_TYPE_ENUM = LOT_CONTRACT_TYPE_ENUM;

    constructor(
        public readonly lotPermissions: LotPermissions,
        private readonly navigationService: NavigationService,
        private releaseStagesLogicService: ReleaseStagesLogicService
    ) {
    }

    public ngOnInit(): void {
        this.loadLots();
    }

    public lotTypeDisplay = (value: LotTypeEnumId) => startCase(LOT_TYPE_ENUM[value]);
    public siteStatusDisplay = (value: SiteStatusEnumId) => startCase(SITE_STATUS_ENUM[value]);



    public viewLot(lot: IProjectReleaseLotFinancesDto): void {
        this.navigationService.navigate([`lots/${lot.id}/summary`]);
    }

    private loadLots = () => {
        this.loaded = false;
        this.releaseStagesLogicService.costSummaryLots(this.releaseId).pipe(take(1)).subscribe((result) => {
            this.lots = result;
            this.loaded = true;
        });
    };

}
